import { render, staticRenderFns } from "./CustomerClub.vue?vue&type=template&id=239bc892&"
import script from "./CustomerClub.vue?vue&type=script&lang=js&"
export * from "./CustomerClub.vue?vue&type=script&lang=js&"
import style0 from "./CustomerClub.vue?vue&type=style&index=0&id=239bc892&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports